import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import get from 'lodash/get';
import find from 'lodash/find';

var propTypes = {
  paramName: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  hideArrow: PropTypes.bool,
  className: PropTypes.string
};

var defaultProps = {
  placeholder: 'Select...',
  hideArrow: false,
  className: null
};

var Dropdown = function (_PureComponent) {
  _inherits(Dropdown, _PureComponent);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.toggle = function (event) {
      if (_this.props.disabled) {
        return;
      }
      if (_this.props.onFocus && typeof _this.props.onFocus === 'function') {
        _this.props.onFocus(_this.state.isOpen);
      }
      event.stopPropagation();
      event.preventDefault();

      _this.setState({
        isOpen: !_this.state.isOpen
      });
    };

    _this.setValue = function (value, label) {
      var newState = {
        isOpen: false
      };
      if (value !== _this.props.value && _this.props.onChange && typeof _this.props.onChange === 'function') {
        _this.props.onChange({ paramName: _this.props.paramName, value: value });
      }
      _this.setState(newState);
    };

    _this.handleDocumentClick = function (event) {
      if (!ReactDOM.findDOMNode(_this).contains(event.target)) {
        if (_this.state.isOpen) {
          _this.setState({ isOpen: false });
        }
      }
    };

    _this.findLabelWithValue = function (value) {
      var option = find(_this.props.options, ['value', value]);
      return option ? option.label : null;
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleDocumentClick, false);
    }
  }, {
    key: 'renderOption',
    value: function renderOption(option) {
      var _this2 = this;

      var value = option.value;
      if (typeof value === 'undefined') {
        value = option.label || option;
      }
      var label = option.label || option.value || option;
      var isSelected = value === this.props.value;

      return React.createElement(
        'div',
        {
          key: value,
          className: 'dropdown-option' + (isSelected ? ' is-selected' : ''),
          onClick: function onClick() {
            return _this2.setValue(value, label);
          } },
        label
      );
    }
  }, {
    key: 'buildMenu',
    value: function buildMenu() {
      var _this3 = this;

      var options = this.props.options;

      var ops = options.map(function (option) {
        if (option.type === 'group') {
          var groupTitle = React.createElement(
            'div',
            { className: 'dropdown-title' },
            option.name
          );
          var _options = option.items.map(function (item) {
            return _this3.renderOption(item);
          });

          return React.createElement(
            'div',
            { className: 'dropdown-group', key: option.name },
            groupTitle,
            _options
          );
        } else {
          return _this3.renderOption(option);
        }
      });

      return ops.length ? ops : React.createElement(
        'div',
        { className: 'dropdown-noresults' },
        'No options found'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          hideArrow = _props.hideArrow,
          disabled = _props.disabled,
          placeholder = _props.placeholder,
          value = _props.value;
      var isOpen = this.state.isOpen;

      var isOpenClass = isOpen ? ' is-open' : '';
      var disabledClass = disabled ? ' dropdown-disabled' : '';
      var hideArrowClass = hideArrow ? ' dropdown-no-arrow' : '';
      var placeHolderValue = this.findLabelWithValue(value) || placeholder;

      return React.createElement(
        'div',
        { className: 'dropdown-root' + isOpenClass + (className ? ' ' + className : '') },
        React.createElement(
          'div',
          { className: 'dropdown-control' + disabledClass + hideArrowClass, onClick: this.toggle },
          React.createElement(
            'div',
            { className: 'dropdown-placeholder' },
            placeHolderValue
          ),
          !hideArrow && React.createElement('span', { className: 'dropdown-arrow' })
        ),
        isOpen && React.createElement(
          'div',
          { className: 'dropdown-menu' },
          this.buildMenu()
        )
      );
    }
  }]);

  return Dropdown;
}(PureComponent);

Dropdown.defaultProps = defaultProps;
Dropdown.propTypes = propTypes;

export default Dropdown;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Dropdown/index.js
// module id = 466
// module chunks = 0